import { useMemo } from "react";

import { Bulb } from "components/icons/generated";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import type { MainNavigationItem } from "../types";
import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useInsightsGroup = (): MainNavigationItem | undefined => {
  const { viewer } = useTypedContext(AccountContext);

  const notificationsItem = useMemo(
    () =>
      viewer.admin
        ? [MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Notifications]]
        : [],
    [viewer.admin]
  );

  return useMemo(() => {
    return {
      id: "insights",
      title: "Get Insights",
      icon: Bulb,
      items: [
        {
          items: [
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Dashboard],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Launchpad],
            ...notificationsItem,
          ],
        },
      ],
    };
  }, [notificationsItem]);
};

export default useInsightsGroup;
